import { POST } from '@/utils/axios'

export const addTranslation = async formData =>
  await POST('/add-translation', formData, { useAuthorization: true })
